import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';
import { ScrollSyncDirective } from '@rma/generic/ui/scroll-sync';
import { OverflowScrollDirective, ScrollChevronComponent } from '@rma/public/generic/public/ui-overflow-scroll';
import { COMPARE_AGENT_SCOPE } from '../domain/translation-scope';
import { AddAgentSlotComponent } from '../ui-add-agent-slot/add-agent-slot.component';
import { AgentCardComponent, AgentCardDetails } from '../ui-agent-card/agent-card.component';

@Component({
  selector: 'rma-agent-cards-row',
  templateUrl: './agent-cards-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope(COMPARE_AGENT_SCOPE)],
  imports: [
    AddAgentSlotComponent,
    AgentCardComponent,
    OverflowScrollDirective,
    ScrollChevronComponent,
    ScrollSyncDirective,
    TranslocoDirective,
  ],
  host: {
    class: 'sticky top-(--header-height) z-20 block bg-white',
  },
})
export class AgentCardsRowComponent {
  protected readonly scope = COMPARE_AGENT_SCOPE;

  readonly agents = input.required<readonly AgentCardDetails[]>();
  readonly showAddSlot = input(true);

  readonly removeAgent = output<string>();
}
